/**
 * CompareSubmenuRow - Selectable row for compare submenu items
 *
 * Displays a submenu item (player, watchlist, position, etc.) in the selection modal.
 */

export { default } from "./CompareSubmenuRowContainer";
export { default as CompareSubmenuRow } from "./CompareSubmenuRowContainer";
